const NESTED_INTERACTIVE_SELECTOR = [
  "button",
  "a[href]",
  "input",
  "select",
  "textarea",
  "summary",
  "[role='button']",
  "[role='checkbox']",
  "[role='link']",
  "[role='menuitem']",
  "[role='option']",
  "[role='radio']",
  "[role='switch']",
].join(", ");

export function isNestedInteractiveEvent(event) {
  if (event.defaultPrevented) {
    return true;
  }

  const target = event.target;
  if (!(target instanceof Element)) {
    return false;
  }

  const interactiveElement = target.closest(NESTED_INTERACTIVE_SELECTOR);
  return Boolean(interactiveElement && interactiveElement !== event.currentTarget);
}